import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { Swiper, SwiperSlide } from 'swiper/react'

export const ImageCarousel = ({ carouselItems }) => {
	return (
		<div>
			<Swiper
				slidesPerView={'6'}
				breakpoints={{
					0: { slidesPerView: 2 },
					500: { slidesPerView: 3 },
					768: { slidesPerView: 4 },
					990: { slidesPerView: 6 },
				}}
				spaceBetween={20}
				modules={[Navigation]}
				navigation
				className='multiColumnCarousel flex'
			>
				{carouselItems.map(item => {
					return (
						<SwiperSlide key={item.id}>
							<div className=''>
								<div className='ratio-4-5 pos-rel overflow'>
									<GatsbyImage className='bg-image' image={item?.image?.gatsbyImageData} alt={item?.image?.alt || item?.caption || 'Property Image'} />
								</div>
								<p className='op-50 m0 pt10'>{item.caption}</p>
							</div>
						</SwiperSlide>
					)
				})}
				<div className='mask left' />
				<div className='mask right' />
			</Swiper>
		</div>
	)
}

export const VideoCarousel = ({ carouselItems }) => {
	return (
		<div>
			<Swiper
				slidesPerView={'3'}
				breakpoints={{
					0: { slidesPerView: 1.6 },
					500: { slidesPerView: 1.6 },
					768: { slidesPerView: 1.6 },
					990: { slidesPerView: 3 },
				}}
				spaceBetween={20}
				modules={[Navigation]}
				navigation
				className='multiColumnCarousel flex'
			>
				{carouselItems.map(item => {
					return (
						<SwiperSlide key={item.id}>
							<a href={item.youtube} target='_blank' rel='noreferrer' className=''>
								<div className='ratio-4-3 pos-rel overflow'>
									<div className='play-icon' />
									<GatsbyImage className='bg-image dim' image={item?.thumbnail?.gatsbyImageData} alt={item?.thumbnail?.alt || item?.title || ''} />
								</div>
								{item.title && <p className='op-50 m0 pt10'>{item.title}</p>}
							</a>
						</SwiperSlide>
					)
				})}
				<div className='mask left' />
				<div className='mask right' />
			</Swiper>
		</div>
	)
}
